import { bannerMetricsPublisher } from 'src/features/header/components/Banners/types';
import { logWithTakt } from '../../utils/logWithTakt';
import { BANNER_LEVEL } from 'src/app/slice';

export const clickLinkHandler = (
  bannerLevel: BANNER_LEVEL,
  bannerId: string,
) => {
  if (bannerLevel === BANNER_LEVEL.CONSOLE) {
    bannerMetricsPublisher[bannerLevel].publishCounterMonitor(
      `bannerLinkClicked:${bannerId}`,
      1,
    );
    logWithTakt(`${bannerLevel}BannerClicked`, {
      bannerId: bannerId,
    });
  }
};
